<template>
    <div class="complimentary">
      <div class="arrow arrow-L" v-bind:class="{ hidden: !showLeftArrow }" v-on:click="slideGrid('left')">
        <img src="../../../assets/img/arrow-black.svg" alt='' 
            v-bind:class="{'slided': slide === 'right'}"/>
        <label>{{ slide === 'right' ? 'Main Panel' : 'Side Panels' }}</label>
      </div>
      <div class="arrow arrow-R" v-bind:class="{ hidden: !showRightArrow }" v-on:click="slideGrid('right')">
        <label>{{ slide === 'left' ? 'Main Panel' : 'Side Panels' }}</label>
        <img src="../../../assets/img/arrow-black.svg" alt='' 
            v-bind:class="{'slided': slide === 'left'}"/>
      </div>
    </div>
</template>

<script>

export default {
  name: 'SlideWhitesColorbond',
  props: {
    allowSlide: { type: Boolean },
    slide: { type: String },
    wallType: String
  },
  computed: {
    showLeftArrow() {
      return (this.wallType === 'small' || this.slide === 'right') && this.slide !== 'left'
    },
    showRightArrow() {
      return (this.wallType === 'large' || this.slide === 'left') && this.slide !== 'right'
    }
  },
  methods: {
    slideGrid(arrow) {
      if (arrow === 'left' && this.slide !== 'right') {
        this.$emit('slideGrid', 'left')
      } else if (arrow === 'left' && this.slide === 'right')  {
        this.$emit('slideGrid', 'centerFromL')
      }else if(arrow === 'right' && this.slide !== 'left') {
        this.$emit('slideGrid', 'right')
      }else if(arrow === 'right' && this.slide === 'left') {
        this.$emit('slideGrid', 'centerFromR')
      } 
    }
  }
}
</script>